// Exotics widgets share PricingProvider (architect E8). Thin pass-through.
import type { FC } from 'react';

import ExoticsSabrBandWidget from './exotics-sabr-band-widget';
import type { ExoticsSabrBandProps } from './types';

const ExoticsSabrBandWrapperProvider: FC<ExoticsSabrBandProps> = (props) => (
  <ExoticsSabrBandWidget {...props} />
);

export default ExoticsSabrBandWrapperProvider;
